import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {GenericFilterObject} from '../../shared/models/generic-filter-object.model';
import {Observable} from 'rxjs';
import {IPagedResponse} from '../../shared/models/IPageResponse';
import {map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import { Associate } from '../../shared/models/associates/associate.model';
import { AssociateDetails } from '../../shared/models/associates/associate-details.model';
import { LoginService } from './login.service';
import { UtilsService } from './utils.service';
import {MerchandiserGetStream} from "../../shared/models/getstream/merchandiser-get-stream.model";

@Injectable({
  providedIn: 'root'
})
export class AssociateService {

  constructor(private http: HttpClient,
              private loginService: LoginService) { }

  public getAssociates(genericFilterObj: GenericFilterObject, terr: number, ownedBy: boolean): Observable<IPagedResponse<Associate>> {
    const country = this.loginService._country;
    let params: HttpParams = null;

    params = new HttpParams();
    if (genericFilterObj.form != null) {
      Object.entries(genericFilterObj.form as Record<string, unknown>).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== '') {
          params = params.append(key, String(value));
        }
      });
    }

    if (!genericFilterObj.page || typeof genericFilterObj.page === 'object') {
      params = params.append('size', genericFilterObj.page.size.toString());
      params = params.append('page', genericFilterObj.page.page.toString());

      if (genericFilterObj.page.sort && genericFilterObj.page.sort.length > 0) {
        genericFilterObj.page.sort.forEach(s => {
          params = params.append('sort', s);
        });
      }
    } else {
      params = params.append('size', '10');
      params = params.append('page', '0');
    }

    params = params.append('ownedBy', ownedBy);
    return this.http.get<IPagedResponse<Associate>>(
        `${environment.apiResourceUri}/merchandisers/country/${country}/territory/${terr}`, {params: params})
      .pipe(map((res: IPagedResponse<Associate>) => {
        if (res?.size > 0) {
          res?.content?.forEach(associate => {
            if (associate.lastTrainMs) {
              associate.lastTrainMs = UtilsService.dateToServerDate(associate.lastTrainMs);
            }
            if (associate.lastTrainAd) {
              associate.lastTrainAd = UtilsService.dateToServerDate(associate.lastTrainAd);
            }
          });
        }
        return res;
      }));
  }

  public getAssociateDetails(associateId: number): Observable<AssociateDetails> {
    return this.http.get<AssociateDetails>(`${environment.apiResourceUri}/merchandisers/${associateId}/details`)
      .pipe(map((response: AssociateDetails) => {
        if (response.lastTrainMs) {
          response.lastTrainMs = UtilsService.dateToServerDate(response.lastTrainMs);
        }
        if (response.lastTrainAd) {
          response.lastTrainAd = UtilsService.dateToServerDate(response.lastTrainAd);
        }
        return response;
      }));
  }

  public getAssociateByRetailerId(retailerId: number): Observable<Associate> {
    return this.http.get<Associate>(
      `${environment.apiResourceUri}/merchandisers/retailer/${retailerId}`)
      .pipe(map((response: Associate) => {
        if (response.lastTrainMs) {
          response.lastTrainMs = UtilsService.dateToServerDate(response.lastTrainMs);
        }
        if (response.lastTrainAd) {
          response.lastTrainAd = UtilsService.dateToServerDate(response.lastTrainAd);
        }
        return response;
      }));
  }

  public getAssociateById(merchandiserId: number): Observable<Associate> {
    return this.http.get<Associate>(`${environment.apiResourceUri}/merchandisers/merchandiser/${merchandiserId}`)
    .pipe(map((response: Associate) => {
        if (response.lastTrainMs) {
          response.lastTrainMs = UtilsService.dateToServerDate(response.lastTrainMs);
        }
        if (response.lastTrainAd) {
          response.lastTrainAd = UtilsService.dateToServerDate(response.lastTrainAd);
        }
        return response;
    }));
  }

  public getAssociateByScheduleId(scheduleId: string): Observable<Associate> {
    return this.http.get<Associate>(`${environment.apiResourceUri}/merchandisers/schedule/${scheduleId}`)
      .pipe(map((response: Associate) => {
        if (response.lastTrainMs) {
          response.lastTrainMs = UtilsService.dateToServerDate(response.lastTrainMs);
        }
        if (response.lastTrainAd) {
          response.lastTrainAd = UtilsService.dateToServerDate(response.lastTrainAd);
        }
        return response;
      }));
  }

  autocompleteUsers(searchBy: string): Observable<MerchandiserGetStream[]> {
    const territory = localStorage.getItem('territory');
    return this.http.get<MerchandiserGetStream[]>(
      `${environment.apiResourceUri}/merchandisers/search/${searchBy}/territory/${territory}`);
  }

  public getMerchandiserByUserId(userId: string): Observable<number> {
    return this.http.get<number>(`${environment.apiResourceUri}/merchandisers/username/${userId}`);
  }
}
